import { request as queryRequest } from './reducers/query';
import { request as settleManuallyRequest } from './reducers/settle-manually';
import { request as settleRequest } from './reducers/settle';
import { request as calculatePayoutRequest } from './reducers/calculate-payout';
import { request as commentBetRequest } from './reducers/comment-bet';
import { request as parkBetRequest } from './reducers/park-bet';
import { request as cancelBetRequest } from './reducers/cancel-bet';
import { request as betUnsettlementRequest } from './reducers/unsettlement';

// eslint-disable-next-line import/no-default-export
export default {
    BETS_QUERY_REQUEST: queryRequest,
    BETS_SETTLE_MANUALLY_REQUEST: settleManuallyRequest,
    BETS_SETTLE_REQUEST: settleRequest,
    BETS_CALCULATE_PAYOUT_REQUEST: calculatePayoutRequest,
    BETS_COMMENT_BET_REQUEST: commentBetRequest,
    BETS_PARK_BET_REQUEST: parkBetRequest,
    BETS_UNSETTLEMENT_REQUEST: betUnsettlementRequest,
    BETS_CANCEL_BET_REQUEST: cancelBetRequest,
};
